import { createBrowserHistory } from 'history'
import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Router } from 'react-router'
import { GoogleOAuthProvider } from '@react-oauth/google'
import ReactGA from 'react-ga4'
import { ThemeProvider } from 'styled-components'

// Utils
import routes, { brandingRoutes, isBrandingHost } from './constants/routes'
import initGa from './utils/googleAnalytics'
import { getInitialTheme } from './utils/companyThemeCache'
import './i18n'

// Components
import MainSkeleton from './components/fallBack/MainSkeleton'
import App from './App'

const googleTag = process.env.REACT_APP_GOOGLE_TAG
if (googleTag) ReactGA.initialize(process.env.REACT_APP_GOOGLE_TAG || '')

const history = createBrowserHistory()
initGa(history)
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''
export const WrappedApp = (
  <HelmetProvider>
    <Suspense
      fallback={
        // Outside App's ThemeProvider, so the skeleton gets the cached theme here
        <ThemeProvider theme={getInitialTheme()}>
          <MainSkeleton />
        </ThemeProvider>
      }
    >
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <Router history={history}>
          <App routes={isBrandingHost() ? brandingRoutes : routes} />
        </Router>
      </GoogleOAuthProvider>
    </Suspense>
  </HelmetProvider>
)

export const init = (el: HTMLElement | null) => {
  if (el) {
    createRoot(el).render(WrappedApp)
  }
}

init(document.getElementById('root'))
